<template>
  <div
    class="flex items-center justify-between text-white"
    :class="{
      'flex-row': reverse,
      'flex-col': !reverse,
    }"
  >
    <h1 class="text-info text-sm font-medium">{{ title }}</h1>
    <p
      class="bg-gray-5 rounded border border-block-2 py-0.5 px-2 flex items-center justify-center text-center text-sm gap-1.5"
      :class="{
        'text-success': success,
        'text-danger': danger,
      }"
    >
      <a
        v-if="link"
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ value }}
      </a>
      <span v-else>
        {{ value }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "CollateralText",
  props: {
    title: { type: String },
    value: { type: [String, Number] },
    link: { type: String, default: null },
    success: { type: Boolean },
    danger: { type: Boolean },
    reverse: { type: Boolean },
  },
};
</script>
